import React, { useEffect } from 'react';

import type { LeaseActionProps } from '../../../models/Types';
import SignedSelfUploadSigningCompleteModal from '../../../pages/LandlordLeaseView/ListView/LeaseSignPreview/SignedSelfUploadSigningCompleteModal';
import { useMarkAsSignedMutation } from '../../../utils/queries';
import { LeaseArtifactType } from '@zg-rentals/ts-leasing-client';

export default function FinalizeSignedSelfUpload({ lease, terminateActiveAction }: LeaseActionProps) {
  const markAsSignedMutation = useMarkAsSignedMutation();

  useEffect(() => {
    markAsSignedMutation.mutate({
      postData: {
        leaseArtifactType: LeaseArtifactType.LEASE,
        leaseArtifactId: lease.id as unknown as number,
      },
    });
  }, []);

  function onClose() {
    terminateActiveAction();
  }

  return <SignedSelfUploadSigningCompleteModal isOpen={false} onClose={onClose} lease={lease} />;
}
